import type {
  ContentObject,
  ContentTypeDefinition,
} from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type GridRenderFieldEventInit = {
  /** Full path to the field within the object */
  accessor: string;
  /** Field value */
  data: any;
  /** Field input type */
  inputType: string;
  /** An entire object that is being rendered */
  contentObject: ContentObject;
  /** Content type that includes the field */
  contentType: ContentTypeDefinition;
  /** Content type api name */
  contentTypeName: string;
};

/**
 * An event that is fired when a field is rendered in the grid.
 * Returning anything will embed that result in the grid cell for the field.
 *
 * @memberof FlotiqPlugins.Events
 * @eventName "flotiq.grid.cell::render"
 * @returns {null|string|array|number|boolean|HTMLElement|ReactElement}
 *          Null if rendering should be passed to either Flotiq or other plugins.
 *          Renderable result if plugin wants to replace the default renderer.
 */
export class GridRenderFieldEvent extends IFlotiqPluginEvent {
  constructor(initData: GridRenderFieldEventInit) {
    super(initData);
  }
}
